import React, { Component } from 'react';

import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.pageWidth > 992 ? (
          <Desktop {...this.props} />
        ) : (
          <Mobile {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js